import { InvoiceNominateLogic } from 'components/InvoiceNominateMonth';
import { InvoiceInterface } from 'constants/invoice';
import React from 'react';
import { PriceFormat } from 'services/price';

import {
  Content,
  Item,
  ItemText,
  ItemValueText,
  ItemTotalText,
  ItemTotal,
  InvoiceDetailCard,
  ContentDivider,
  ItemWithMargin,
  ItemValueTextLastInvoicePayment
} from './styles';

interface InvoiceDetailComponentProps {
  invoice: InvoiceInterface | undefined;
}

const InvoiceDetailComponent: React.FC<InvoiceDetailComponentProps> = ({
  invoice
}) => {
  const invoiceMonth = InvoiceNominateLogic(invoice);

  return (
    <InvoiceDetailCard
      title={`Detalhes da fatura de ${invoiceMonth?.month}`}
      iconName="invoice"
    >
      <Content>
        <ItemWithMargin>
          <ItemText bold>Fatura anterior</ItemText>
          <ItemValueText bold>
            R$ {PriceFormat(invoice?.previousInvoiceValue)}
          </ItemValueText>
        </ItemWithMargin>
        <ItemWithMargin>
          <ItemText>Pagamento efetuado</ItemText>
          <ItemValueTextLastInvoicePayment>
            (-) R$ {PriceFormat(invoice?.lastInvoicePayment ?? 0)}
          </ItemValueTextLastInvoicePayment>
        </ItemWithMargin>
        <Item>
          <ItemText>Saldo total</ItemText>
          <ItemValueText>
            R$ {PriceFormat(invoice?.remainingBalance)}
          </ItemValueText>
        </Item>
        <ContentDivider />
        <ItemWithMargin>
          <ItemText>Compras nacionais</ItemText>
          <ItemValueText>
            R$ {PriceFormat(invoice?.nationalPurchasesTotal)}
          </ItemValueText>
        </ItemWithMargin>
        <ItemWithMargin>
          <ItemText>Compras internacionais</ItemText>
          <ItemValueText>
            R$ {PriceFormat(invoice?.internationalPurchasesTotal)}
          </ItemValueText>
        </ItemWithMargin>
        <ItemWithMargin>
          <ItemText>Retiradas no exterior</ItemText>
          <ItemValueText>
            R$ {PriceFormat(invoice?.totalForeignWithdraw)}
          </ItemValueText>
        </ItemWithMargin>
        <ItemWithMargin>
          <ItemText>Total de repasse IOF</ItemText>
          <ItemValueText>R$ {PriceFormat(invoice?.iofTotal)}</ItemValueText>
        </ItemWithMargin>
        <ItemWithMargin>
          <ItemText>Encargos e serviços</ItemText>
          <ItemValueText>
            R$ {PriceFormat(invoice?.chargesAndServices)}
          </ItemValueText>
        </ItemWithMargin>
      </Content>
      <ItemTotal>
        <ItemTotalText>Total para essa fatura</ItemTotalText>
        <ItemTotalText>R$ {PriceFormat(invoice?.value)}</ItemTotalText>
      </ItemTotal>
    </InvoiceDetailCard>
  );
};

export default InvoiceDetailComponent;
